import { ApiAccount, ApiSync, ApiSyncType } from "@incendium/api";
import { CloudSync } from "@mui/icons-material";
import { Autocomplete, Button, Stack, TextField } from "@mui/material";
import { Box } from "@mui/system";
import { capitalize } from "lodash";
import { useCallback, useMemo, useState } from "react";

interface ISyncAccountSelectorProps {
  connectionAccounts: ApiAccount[];
  syncs: ApiSync[];
  provider: string;
  type: ApiSyncType
  onLinkAccount: (a: ApiAccount) => void;
}

function SyncAccountSelector({
  connectionAccounts,
  syncs,
  provider,
  type,
  onLinkAccount,
}: ISyncAccountSelectorProps) {
  const [selectedAccount, setSelectedAccount] = useState<ApiAccount | null>(
    null
  );

  const options = useMemo(() => {
    const syncIds = syncs.map((s) => s.account);
    return connectionAccounts.filter((c) => !syncIds.includes(c.externalId));
  }, [syncs, connectionAccounts]);

  const linkAccount = useCallback(() => {
    onLinkAccount(selectedAccount!);
    setSelectedAccount(null);
  }, [selectedAccount, onLinkAccount]);

  return (
    <Box>
      <Autocomplete
        size="small"
        onChange={(e, value) => {
          setSelectedAccount(value);
        }}
        value={selectedAccount}
        options={options}
        getOptionLabel={(o) => `${o.name} - ${o.externalId?.split("/")[1] || o.externalId}`}
        groupBy={type === ApiSyncType.GOOGLE_ADS ? (o) => o.parentName || o.name || "Other" : undefined}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label={`${capitalize(provider)} Account`}
          />
        )}
      />
      <Stack mt={2} direction="row" spacing={2} justifyContent="flex-end">
        <Button
          startIcon={<CloudSync />}
          onClick={linkAccount}
          disabled={!selectedAccount}
        >
          Sync Account
        </Button>
      </Stack>
    </Box>
  );
}

export default SyncAccountSelector;
